import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { StandalonePageShell } from "@/components/site/StandalonePageShell";
import { Testimonials } from "@/components/site/Testimonials";
import { MANIFESTO } from "@/constants/site";
import { Reveal } from "@/lib/motion";
import { useSiteContent } from "@/lib/useSiteContent";

export default function CorporatePage() {
  const { t } = useTranslation();
  const home = useSiteContent("home");
  const contact = useSiteContent("contact");
  const dealers = useSiteContent("dealers");
  const chapters = home.story_chapters?.length
    ? home.story_chapters.map((chapter, index) => ({ ...chapter, no: String(index + 1).padStart(2, "0") }))
    : MANIFESTO;

  return (
    <StandalonePageShell
      content={{ home, contact, dealers }}
      eyebrow={t("pages.corporate.eyebrow")}
      title={home.about_title || t("pages.corporate.title")}
      description={home.about_description || t("pages.corporate.description")}
    >
      <section data-testid="corporate-page" className="bg-surface px-5 py-20 sm:px-8 lg:py-28">
        <div className="mx-auto grid max-w-7xl gap-5 lg:grid-cols-3">
          {chapters.map((chapter, index) => (
            <Reveal key={`${chapter.no}-${chapter.title}`} delay={index * 0.08}>
              <motion.article whileHover={{ y: -6 }} className="h-full rounded-[2rem] border border-detail bg-cream p-7 sm:p-8">
                <span className="font-heading text-5xl font-bold tabular-nums text-brand/25">{chapter.no}</span>
                <h2 className="mt-10 font-heading text-2xl font-bold text-ink">{chapter.title}</h2>
                <p className="mt-4 leading-relaxed text-ink/65">{chapter.text}</p>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </section>
      <Testimonials content={home} />
    </StandalonePageShell>
  );
}
